module.exports = __webpack_public_path__ + "img/qykt.d7e46d7c.jpg";